import {useRouter} from 'next/router';

import {safelySetInnerHTML} from '@udemy/shared-utils';

function updateAnchorLinksWithPath(text: string, currentPath: string) {
    // Regular expression to find href attributes that start with # and group it
    const regex = /href=['"]([^'"]+)['"]/g;

    /**
     * Replace the href attribute to include the current path
     * Currently, anchor links need to return without path which in general we don't need it for anchor links.
     * For example "#terms-of-use-accounts"
     *
     * But since next.js router is not working as expect, it does not handle these anchor links correctly and tries to
     * redirect users to a new page not handles anchors. It expects us to use <Link/> component from next/link which
     * we cannot to currently/
     *
     */
    const updatedText = text?.replaceAll(regex, (match, p1) => {
        return p1.startsWith('#') ? `href="${currentPath}${p1}"` : `href="${p1}"`;
    });
    return updatedText;
}

export function TermsPage({content}: {content: string}) {
    const router = useRouter();
    const currentPathName = router.asPath.split('#')[0];
    return (
        <section>
            <div
                id="terms"
                role="presentation"
                className="ud-text-with-links"
                {...safelySetInnerHTML({
                    descriptionOfCaller: 'terms-page',
                    html: updateAnchorLinksWithPath(content, currentPathName),
                })}
            />
        </section>
    );
}
